import React from 'react';


export const PriceColumnFormatter = (
    cellContent,
        row,
        rowIndex
) => (
    <span>{cellContent.toLocaleString()} ریال</span>
)